export interface StringComboboxLabels {
  fieldLabel: string;
  openListAriaLabel: string;
  searchAriaLabel: string;
  emptyText: string;
  noResultsText: string;
  removeItemTitle: string;
  optionIdPrefix: string;
}

export const parseVendorsResponse = (response: { success: boolean; data?: unknown }): string[] => {
  if (!response.success || !response.data) return [];
  const payload = response.data as Record<string, unknown>;
  const vendors =
    (payload?.data as Record<string, unknown> | undefined)?.vendors ||
    payload?.vendors ||
    (Array.isArray(payload) ? payload : []);
  return Array.isArray(vendors) ? vendors.filter((v): v is string => typeof v === 'string') : [];
};

export const parseProjectTagsResponse = (response: { success: boolean; data?: unknown }): string[] => {
  if (!response.success || !response.data) return [];
  const payload = response.data as Record<string, unknown>;
  const projectTags =
    (payload?.data as Record<string, unknown> | undefined)?.project_tags ||
    payload?.project_tags ||
    (Array.isArray(payload) ? payload : []);
  return Array.isArray(projectTags) ? projectTags.filter((v): v is string => typeof v === 'string') : [];
};

export const textDirection = (value: string): 'ltr' | 'rtl' => {
  for (const char of value.trim()) {
    if (/[A-Za-z0-9]/.test(char)) return 'ltr';
    if (/[\u0590-\u08FF]/.test(char)) return 'rtl';
  }
  return 'rtl';
};
